export default function validNumber() {
  'ngInject';

  return {
    require: 'ngModel',
    link($scope, $element, $attrs, $ctrl) {
      let isValid = () => true;
      let isTypeValid = () => true;
      let isRangeValid = () => true;

      switch ($attrs.validNumber) {
        case 'positive':
          isValid = (x) => x > 0;
          break;
        case 'negative':
          isValid = (x) => x < 0;
          break;
        case 'non-positive':
          isValid = (x) => x <= 0;
          break;
        case 'non-negative':
          isValid = (x) => x >= 0;
          break;
        default:
      }

      if ('validNumberGreaterThan' in $attrs) {
        isRangeValid = (x) => x > $scope.$eval($attrs.validNumberGreaterThan);
        $scope.$watch($attrs.validNumberGreaterThan, () => $ctrl.$validate());
      }

      if ('validNumberLowerThan' in $attrs) {
        isRangeValid = (x) => x < $scope.$eval($attrs.validNumberLowerThan);
        $scope.$watch($attrs.validNumberLowerThan, () => $ctrl.$validate());
      }

      if ('validNumberGreaterOrEqualThan' in $attrs) {
        isRangeValid = (x) => x >= $scope.$eval($attrs.validNumberGreaterOrEqualThan);
        $scope.$watch($attrs.validNumberGreaterOrEqualThan, () => $ctrl.$validate());
      }

      if ('validNumberLowerOrEqualThan' in $attrs) {
        isRangeValid = (x) => x <= $scope.$eval($attrs.validNumberLowerOrEqualThan);
        $scope.$watch($attrs.validNumberLowerOrEqualThan, () => $ctrl.$validate());
      }

      if ($attrs.validNumberType === 'integer') {
        isTypeValid = (x) => Math.floor(x) === x;
      }

      $ctrl.$validators['valid-number'] = (model, view) => {
        if (!view) {
          return true;
        }

        let viewValue = view;
        if ($attrs.addDisplayPostfix) {
          viewValue = viewValue.replace($attrs.addDisplayPostfix, '');
        }

        const number = Number(viewValue);
        if (Number.isNaN(number)) {
          return false;
        }

        return isValid(number) && isTypeValid(number) && isRangeValid(number);
      };

      $ctrl.$parsers.push((value) => {
        if (value) {
          const number = Number(value);
          if (Number.isNaN(number)) {
            $ctrl.$validate();
            return value;
          }

          $ctrl.$validate();
          return number;
        }

        $ctrl.$validate();
        return null;
      });
    },
  };
}
